/**
 * ComparePdfButton.jsx — Bouton « Exporter en PDF » de l'en-tête de la page de
 * comparaison, état de génération et message d'échec lisible.
 * Logique dans useComparePdfExport ; ce composant ne fait que le rendu.
 */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { FileDown } from 'lucide-react';
import { getTheme } from '../constants/theme';
import { semanticColors } from '../constants/semanticColors';

const ComparePdfButton = ({ onClick, generating, disabled, error, darkMode = false }) => {
  const { t: tr } = useTranslation();
  const t = getTheme(darkMode);
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: '6px' }}>
      <button type="button" onClick={onClick} disabled={disabled} aria-busy={generating}
        style={{ padding: '8px 16px', borderRadius: '8px', border: 'none',
          background: t.accent, color: t.surface, fontSize: '13px', fontWeight: '600',
          display: 'inline-flex', alignItems: 'center', gap: '6px',
          cursor: disabled ? 'not-allowed' : 'pointer', opacity: disabled ? 0.6 : 1 }}>
        <FileDown size={14} strokeWidth={2.5} aria-hidden="true" />
        {generating ? tr('sessions.compare.pdf.generating') : tr('sessions.compare.pdf.button')}
      </button>
      {error && (
        <p role="alert" style={{ margin: 0, fontSize: '12px', color: darkMode ? t.danger : semanticColors.redText }}>
          {error}
        </p>
      )}
    </div>
  );
};

export default ComparePdfButton;
